import axios from 'axios';
import { verifyEnvUrl } from '../../util/verifyEnvUrl';

const PRD = 'https://api.acordofechado.com.br/cert';
const HOMOLOG= 'https://us-central1-acordo-fechado-dev.cloudfunctions.net/cert-api-dev';

const certificateApi = axios.create( {
	baseURL: verifyEnvUrl( PRD, HOMOLOG )
} );

certificateApi.interceptors.request.use( async config => {
	const token = localStorage.getItem( 'af-token' );
	if ( token ) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
} );

export default certificateApi;
